import { useCallback, useEffect, useRef, useState } from 'react'
import { notificacoesApi } from './notificacoesApi'

/** Quantas notificações por ler, sem martelar o servidor.
 *
 *  Lê ao abrir, quando a janela volta a ter foco ou fica visível (no
 *  máximo uma vez por minuto) e de 10 em 10 minutos enquanto a página
 *  está visível. Nada de consultas de poucos em poucos segundos: cada
 *  uma acorda a base de dados (o Neon gratuito conta as horas em que
 *  está acordado). Com a página escondida, não lê. */

const INTERVALO_MS = 10 * 60 * 1000
const MINIMO_ENTRE_LEITURAS_MS = 60 * 1000

export function useContagemDeNotificacoes(activo: boolean): {
  porLer: number
  definir: (n: number) => void
  actualizar: () => void
} {
  const [porLer, setPorLer] = useState(0)
  const ultima = useRef(0)

  const ler = useCallback((forcar: boolean) => {
    const agora = Date.now()
    if (!forcar && agora - ultima.current < MINIMO_ENTRE_LEITURAS_MS) return
    ultima.current = agora
    notificacoesApi
      .contagem()
      .then((r) => setPorLer(r.por_ler))
      .catch(() => {
        /* sem servidor: o sino fica como estava */
      })
  }, [])

  useEffect(() => {
    if (!activo) return
    ler(true)
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') ler(false)
    }
    document.addEventListener('visibilitychange', aoVoltar)
    window.addEventListener('focus', aoVoltar)
    const t = window.setInterval(() => {
      if (document.visibilityState === 'visible') ler(true)
    }, INTERVALO_MS)
    return () => {
      document.removeEventListener('visibilitychange', aoVoltar)
      window.removeEventListener('focus', aoVoltar)
      window.clearInterval(t)
    }
  }, [activo, ler])

  return { porLer, definir: setPorLer, actualizar: () => ler(true) }
}
